


























import Vue from "vue";
import AiFeedbackDialog from "./AiFeedbackDialog.vue";
import storeHelper from "@/store/store-helper";
import { AiFeedbackRequest } from "@/types/ai/aiSearch";

export default Vue.extend({
    name: "AiFeedback",
    components: { AiFeedbackDialog },
    props: {
        source: {
            type: String,
            required: true
        },
        contentItemId: {
            type: String,
            required: true
        },
        searchScope: {
            type: String,
            default: () => null
        }
    },
    data: () => ({
        isFeedbackDialogOpen: false
    }),
    methods: {
        handleAIAnswerFeedback() {
            this.isFeedbackDialogOpen = true;
        },
        async submitFeedback(feedbackReason: string) {
            const feedbackScope = storeHelper.aiSearchStore.getFeedbackScope(this.searchScope, this.contentItemId);
            const feedbackInfo: AiFeedbackRequest = {
                search_text: feedbackScope.searchText,
                portal_id: feedbackScope.portalId,
                question_id: feedbackScope.questionId,
                question_index: this.source.includes("qa") ? parseInt(this.source.replace("qa-", "")) : null,
                feedback: feedbackReason
            };
            await storeHelper.aiSearchStore.postAiFeedback(feedbackInfo);
        }
    }
});
